<template>
  <el-dialog
    ref="printContent"
    id="printBox"
    :title="dialogConfig.type ? '新增出库' : '出库详情'"
    v-model="visible"
    width="60%"
    style="overflow: hidden"
    :close-on-click-modal="false"
  >
    <el-collapse v-model="activeNames" v-loading="loading">
      <!--  style="overflow-y: auto; height: 100%" -->
      <el-collapse-item title="出库信息" name="baseMsg">
        <el-form
          :model="formData"
          label-width="100px"
          ref="ruleRef"
          :rules="rules"
          v-if="dialogConfig.type"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="出库单号" prop="number">
                <el-input
                  v-model="formData.number"
                  placeholder="自动生成"
                  :maxlength="40"
                  v-no-space
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="领料申请单" prop="relationNumber">
                <el-input
                  v-model="formData.relationNumber"
                  placeholder="请选择"
                  :maxlength="40"
                  v-no-space
                  @click="handleRequisitionSelectRef"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请人：">
                <el-input
                  v-model="formData.boundUserName"
                  placeholder="选择申请单后自动获取"
                  :maxlength="40"
                  v-no-space
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请时间" prop="boundTime">
                <el-date-picker
                  type="datetime"
                  v-model="formData.boundTime"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择申请单后自动获取"
                  :disabled="true"
                />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="申请部门" prop="requestDepartmentId">
                <el-tree-select
                  v-model="formData.requestDepartmentId"
                  :data="orgTree"
                  placeholder="选择申请单后自动获取"
                  :props="defaultPropsOrg"
                  :show-checkbox="true"
                  :check-strictly="true"
                  node-key="organizationCode"
                  style="width: 100%"
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="部门负责人" prop="departmentHeadId">
                <el-select
                  v-model="formData.departmentHeadId"
                  style="width: 100%"
                  :disabled="true"
                  placeholder="选择申请单后自动获取"
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.nikeName"
                    :value="item.userCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- <el-form-item label="用料时间" prop="useTime">
                <el-date-picker
                  type="datetime"
                  v-model="formData.useTime"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择申请单后自动获取"
                  :disabled="true"
                />
              </el-form-item> -->
              <el-form-item label="工程类型" prop="projectType">
                <el-select
                  v-model="formData.projectType"
                  placeholder="选择申请单后自动获取"
                  style="width: 100%"
                  :disabled="true"
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.dictLabel"
                    :value="String(item.dictValue)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料用途" prop="type">
                <el-select
                  v-model="formData.type"
                  placeholder="选择申请单后自动获取"
                  style="width: 100%"
                  :disabled="true"
                >
                  <el-option
                    v-for="item in materielTypeList"
                    :key="item.id"
                    :label="item.dictLabel"
                    :value="String(item.dictValue)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出库类型：" prop="outType">
                <el-select
                  v-model="formData.outType"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="true"
                >
                  <el-option
                    v-for="item in outStorageTypeList"
                    :key="item.id"
                    :label="item.dictLabel"
                    :value="String(item.dictValue)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type == 2">
              <el-form-item label="工程名称" prop="thirdResourceName">
                <el-input
                  v-model="formData.thirdResourceName"
                  placeholder="选择申请单后自动获取"
                  :maxlength="40"
                  v-no-space
                  @click="handleProjectSelect"
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type == 2">
              <el-form-item label="工程编号" prop="thirdResourceRef">
                <el-input
                  v-model="formData.thirdResourceRef"
                  placeholder="选择申请单后自动获取"
                  :maxlength="40"
                  v-no-space
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type == 3">
              <el-form-item label="厂站名称" prop="thirdResourceId">
                <el-tree-select
                  v-model="formData.thirdResourceId"
                  :data="factoryStationList"
                  node-key="id"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  @node-click="handleNodeClick"
                  :disabled="true"
                  placeholder="选择申请单后自动获取"
                />
              </el-form-item>
            </el-col>

            <el-col>
              <el-form-item label="使用说明： " prop="remark">
                <el-input
                  v-model="formData.remark"
                  type="textarea"
                  :rows="3"
                  :maxlength="200"
                  show-word-limit
                  :disabled="true"
                  placeholder="选择申请单后自动获取"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="出库人签名" prop="deliverySign">
                <el-input
                  v-model="formData.deliverySign"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="领料人签名"
                label-width="auto"
                prop="boundSign"
              >
                <el-input
                  v-model="formData.boundSign"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-descriptions border :column="3" v-else>
          <el-descriptions-item
            label="厂站名称"
            span="1"
            width="16%"
            v-if="formData.outTypeInfo == 3"
          >
            <span class="my_class">{{ formData.organizationName }}</span>
          </el-descriptions-item>
          <el-descriptions-item
            label="工程名称"
            span="1"
            width="16%"
            v-if="formData.outTypeInfo == 2"
          >
            <span class="my_class">{{ formData.thirdResourceName }}</span>
          </el-descriptions-item>
          <el-descriptions-item
            label="工程编号"
            span="1"
            width="16%"
            v-if="formData.outTypeInfo == 2"
          >
            <span class="my_class">{{ formData.thirdResourceRef }}</span>
          </el-descriptions-item>
          <el-descriptions-item
            width="16%"
            v-for="item in descriptionList"
            :key="item.value"
            :label="item.label"
            :span="item.span || 1"
          >
            <span v-if="item.value == 'outType'" class="my_class">
              {{ formData[item.value]?.desc }}</span
            >
            <span v-else class="my_class">{{ formData[item.value] }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>
      <el-collapse-item title="领料申请单" name="sign">
        <div class="flex">
          <el-text type="primary"></el-text>
          <el-button
            type="primary"
            @click="handleFileUpload()"
            v-if="dialogConfig.type"
            >上传附件</el-button
          >
        </div>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          class="mt10"
          :data="tableFileData"
        >
          <el-table-column label="序号" type="index" width="60" fixed />
          <template v-for="item in fileColumns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              :min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
          </template>
          <el-table-column label="操作" fixed="right">
            <template #default="{ row, $index }">
              <el-button
                type="primary"
                link
                @click="handleRemoveFiles($index)"
                v-if="dialogConfig.type"
                >移除</el-button
              >
              <el-button
                type="primary"
                link
                @click="fileDownload(row)"
                v-if="!dialogConfig.type"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <el-collapse-item title="物料信息" name="materiel">
        <div class="flex"></div>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          class="mt10"
          :data="tableData"
        >
          <el-table-column label="序号" type="index" width="60" fixed />
          <template v-for="item in columns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              :min-width="120"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <span v-if="item.prop == 'warehouseId' && !dialogConfig.type">{{
                  row.warehouseName
                }}</span>
                <el-select
                  v-if="item.prop == 'warehouseId' && dialogConfig.type"
                  v-model="row[item.prop]"
                  placeholder="请选择"
                  style="width: 90%"
                >
                  <el-option
                    v-for="item in stashList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" fixed="right" v-if="dialogConfig.type">
            <template #default="{ $index }">
              <el-button type="primary" link @click="handleRemove($index)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <div
      id="hiddenPrintContainer"
      v-show="false"
      class="hidden-print-container"
    ></div>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          v-if="!dialogConfig.type"
          type="primary"
          @click="print()"
          :disabled="buttonLoading"
        >
          打印
        </el-button>
        <el-button @click="handleCancel()">返回</el-button>
        <el-button
          v-if="dialogConfig.type"
          type="primary"
          @click="handleSubmit()"
          :disabled="buttonLoading"
        >
          保存
        </el-button>
      </span>
    </template>

    <!-- 物料选择组件 -->
    <MaterielSelection
      ref="selectRef"
      type="out"
      @selectDone="materielSelectDone"
    />
    <!-- 物料选择组件 -->
    <requisitionSelection
      ref="requisitionSelectRef"
      @selectDone="requisitionSelectDone"
    />
    <!-- 文件导入 -->
    <InStorageFileUpload
      ref="uploadRef"
      @afterUpload="afterUpload"
      :fn="uploadExcelData"
      :uploadConfig="uploadConfig"
    />
  </el-dialog>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { reactive, onMounted, ref } from "vue";
import vueEsign from "vue-esign";
import MaterielSelection from "@/components/MaterielSelection.vue";
import requisitionSelection from "@/components/requisitionSelection.vue";
import useStashList from "../../hooks/useStashList";
import { insertBoundOut } from "@/api/bound";
import { DICT_KEY } from "@/constants/dict";
import { queryDictList } from "@/api/dict";
import { queryStashById } from "@/api/stash";
import { base64ToFile } from "@/utils";
import { uploadFile } from "@/api/file";
import axios from "axios";
import ImageUpload from "@/components/ImageUpload.vue";
import useUserList from "../../hooks/useUserList";
import { queryOrganization } from "@/api/organization";
import { queryRequisitionDetailById, queryDetailById } from "@/api/requisition";
import InStorageFileUpload from "@/components/InStorageFileUpload.vue";
import { postDownload } from "@/utils";
import Print from "@/utils/print";
import { getFactoryStationList } from "@/api/bound";
// 事件绑定
const emits = defineEmits(["afterSave"]);

// 仓库列表
const { stashList } = useStashList();

// 用户列表
const { userList } = useUserList();

//物料用途
const materielTypeList = ref([]);

// 出库类型列表
const outStorageTypeList = ref([
  {
    dictLabel: "维修出库",
    dictValue: "1",
  },
  {
    dictLabel: "工程出库",
    dictValue: "2",
  },
  {
    dictLabel: "生产出库",
    dictValue: "3",
  },
  {
    dictLabel: "其他出库",
    dictValue: "4",
  },
]);

// 当前选中的仓库的库位
const locationList = ref([]);

// 弹窗控制器
const visible = ref(false);

// 签名弹窗控制
const signVisible = ref(false);

// 签名组件
const eSign = ref(null);

// 表单ref
const ruleRef = ref(null);

// 页面
const printContent = ref(null);

// 打印内容
const hiddenPrintContainer = ref(null);

// 物料选择ref
const selectRef = ref(null);

//申请单选择
const requisitionSelectRef = ref(null);

// 保存按钮loading
const buttonLoading = ref(false);

// 遮罩
const loading = ref(false);

// 弹窗打开接收参数
const dialogConfig = ref({});

// 申请人签名
const signImg = ref("");

// 出库人签名
const putinSignImg = ref("");

// 当前选中的签名
const currentSign = ref(1);

// 文件列表
const fileSrc = ref("");

// 物料列表
const tableData = ref([]);

// collapse组件默认展开子级
const activeNames = ref(["baseMsg", "materiel", "sign"]);

// 表单数据
const formData = ref({
  number: null,
  type: null,
  // warehouseId: null,
  boundUserName: null,
  boundTime: null,
  boundUser: null,
  remark: null,
  requestDepartmentId: null,
  departmentHeadId: null,
  useTime: null,
  id: null,
  thirdResourceId: null,
  thirdResourceType: null,
  ref: null,
  thirdResourceName: null,
  departmentHeadText: null,
  requestDepartmentText: null,
  thirdResourceCode: null,
  typeText: null,
  deliverySign: null,
  boundSign: null,
  boundFileReqs: [],
  relationNumber: null,
  outType: null,
  projectType: null,
});

//组织
const orgTree = ref([]);

const defaultPropsOrg = reactive({
  label: "organizationName",
});
//厂站树
const defaultProps = {
  children: "children",
  label: "organizationName",
};
// 描述列表
const descriptionList = ref([
  {
    label: "出库单号",
    value: "number",
  },
  {
    label: "领料申请单",
    value: "relationNumber",
  },
  {
    label: "申请人",
    value: "boundUserName",
  },
  {
    label: "申请时间",
    value: "boundTime",
  },
  {
    label: "申请部门",
    value: "requestDepartmentText",
  },
  {
    label: "部门负责人",
    value: "departmentHeadText",
  },

  {
    label: "工程类型",
    value: "projectTypeName",
  },
  {
    label: "出库类型",
    value: "outType",
    span: 3,
  },
  {
    label: "物料用途",
    value: "typeText",
    span: 3,
  },
  {
    label: "申请人签名",
    value: "deliverySign",
  },
  {
    label: "部门负责人签名",
    value: "boundSign",
  },
]);

// 表单校验规则
const rules = reactive({
  // number: [
  //   { required: true, message: "请输入入库单号", trigger: "blur" },
  //   {
  //     pattern: /^[a-zA-Z0-9]+$/,
  //     message: "只能输入英文和数字",
  //     trigger: "blur",
  //   },
  // ],
  // type: [{ required: true, message: "请选择出库类型", trigger: "blur" }],
  // warehouseId: [{ required: true, message: "请选择出库仓库", trigger: "blur" }],
  // boundUser: [{ required: true, message: "请选择出库人", trigger: "blur" }],
  // deliverySign: [{ required: true, message: "请签名", trigger: "blur" }],
  // boundSign: [{ required: true, message: "请签名", trigger: "blur" }],
  outType: [{ required: true, message: "请选择出库雷旭", trigger: "change" }],
  boundFileReqs: [
    { required: true, message: "请上传领料申请单", trigger: "blur" },
  ],
  relationNumber: [
    { required: true, message: "请选择领料申请单", trigger: "blur" },
  ],
});

//厂站数据
const factoryStationList = ref([]);
// 表格列配置
const columns = ref([
  {
    label: "物料名称",
    prop: "materialName",
  },
  {
    label: "物料编号",
    prop: "number",
  },
  {
    label: "品牌",
    prop: "brand",
  },
  {
    label: "规格型号",
    prop: "model",
  },
  {
    label: "单位",
    prop: "unit",
  },
  {
    label: "申请数量",
    prop: "applyQuantity",
  },
  {
    label: "出库数量",
    prop: "changeQuantity",
  },
  {
    label: "出库仓库",
    prop: "warehouseId",
  },
]);

//获取组织
const getOrg = () => {
  queryOrganization().then((res) => {
    if (JSON.stringify(res.data) != "{}") {
      orgTree.value = res.data || [];
    }
  });
};

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = config;
  formData.value = {
    number: null,
    type: null,
    boundTime: null,
    boundUser: null,
    remark: null,
    requestDepartmentId: null,
    departmentHeadId: null,
    useTime: null,
    id: null,
    thirdResourceId: null,
    thirdResourceType: null,
    ref: null,
    thirdResourceName: null,
    boundUserName: null,
    departmentHeadText: null,
    requestDepartmentText: null,
    thirdResourceCode: null,
    typeText: null,
    deliverySign: null,
    boundSign: null,
    boundFileReqs: [],
    relationNumber: null,
    outType: null,
    outTypeInfo: null,
    projectType: null,
    projectTypeName: null,
  };
  tableFileData.value = [];
  tableData.value = [];
  ruleRef.value?.resetFields();
  if (!config.type) {
    getDetail(config.row.id);
  }
  getOrg();
  getFactoryStation();
  getMaterielTypeList();
  getProjectList();
  // getTypeList();
  visible.value = true;
};

// 获取申请类型列表
const getMaterielTypeList = () => {
  queryDictList(DICT_KEY["boundAcceptMaterial"]).then((res) => {
    materielTypeList.value = res.data || [];
  });
};

// 获取工程类型列表
const projectList = ref([]);
const getProjectList = () => {
  queryDictList(DICT_KEY["storeroom_project_type"]).then((res) => {
    projectList.value = res.data || [];
  });
};

// 根据id查询详情
const getDetail = (id) => {
  loading.value = true;
  queryDetailById(id)
    .then((res) => {
      for (const key in formData.value) {
        formData.value[key] = res.data[key];
      }
      if (res.data.materialList.length > 0) {
        res.data.materialList.forEach((item) => {
          item.changeQuantity = item.applyQuantity;
        });
        tableData.value = res.data.materialList;
      }
      if (formData.value.requestDepartmentId) {
        formData.value.requestDepartmentId =
          formData.value.requestDepartmentId.toString();
      }
      if (res.data.type == 2) {
        formData.value.thirdResourceName = res.data.thirdResourceName;
        formData.value.thirdResourceRef = res.data.thirdResourceRef;
      }
      if (res.data.type == 3) {
        formData.value.authOrganizationalDTO = res.data.authOrganizationalDTO;
      }
      tableFileData.value = res.data.boundFileDTOList || [];
      formData.value.organizationName =
        res.data.authOrganizationalDTO.organizationName || "-";
      formData.value.outTypeInfo = res.data.outType.value;
      console.log(formData.value);
    })
    .finally(() => {
      loading.value = false;
    });
};

// 點擊保存
const handleSubmit = () => {
  buttonLoading.value = true;
  ruleRef.value?.validate((valid) => {
    if (valid) {
      const validateRes = formValidate();
      if (!validateRes) return (buttonLoading.value = false);
      const materialReqs = [...tableData.value];
      let reqBody = {
        ...formData.value,
        id: null,
        materialReqs,
        boundFileReqs: tableFileData.value,
      };
      addBound(reqBody);
    } else {
      buttonLoading.value = false;
    }
  });
};

// 表单提交前校验
const formValidate = () => {
  // // 判断是否有选择物料
  // if (tableData.value.length == 0) {
  //   ElMessage.error("未选择任何物料");
  //   return false;
  // }

  // // 判断物料列表中的数量是否填充完毕
  // const arr = tableData.value.filter((item) => {
  //   return item.changeQuantity;
  // });

  // if (arr.length == 0) {
  //   ElMessage.error("数量是必填项");
  //   return false;
  // }
  return true;
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};
// // 点击签名
// const handleSign = (type) => {
//   currentSign.value = type;
//   signVisible.value = true;
// };

// // 签名重写
// const handleReWrite = () => {
//   eSign.value?.reset();
// };

// // 生成签名
// const handleGenerate = () => {
//   eSign.value
//     // ?.generate({ format: "image/jpeg", quality: 0.5 })
//     ?.generate() // base64默认
//     .then((res) => {
//       if (currentSign.value == 1) {
//         signImg.value = res;
//         uploadSign(res, "申请人.jpg", "deliverySign");
//       } else {
//         putinSignImg.value = res;
//         uploadSign(res, "出库人.jpg", "boundSign");
//       }
//       handleReWrite();
//       signVisible.value = false;
//     })
//     .catch((e) => {
//       ElMessage.error("未识别到签名");
//       console.log(e);
//     });
// };

// 上传签名
const uploadSign = (dataUrl, name, type, isFile) => {
  if (!dataUrl) return;
  let result;
  let file;
  let reqBody = new FormData();
  file = isFile ? dataUrl : base64ToFile(dataUrl, name);

  reqBody.append("file", file);
  uploadFile(reqBody).then((res) => {
    formData.value[type][0] = res.data;
  });
};

//获取厂站
const getFactoryStation = () => {
  getFactoryStationList().then((res) => {
    factoryStationList.value = res.data;
  });
};

// 表格移除
const handleRemove = (index) => {
  tableData.value.splice(index, 1);
};

// 选择物料
const handleMaterielSelect = () => {
  if (!formData.value.warehouseId) return ElMessage.warning("请先选择出库仓库");
  const ids = [];
  tableData.value.forEach((item) => {
    ids.push(item.quantityId);
  });
  selectRef.value?.handleDialogOpen(ids, formData.value.warehouseId, true);
};

// 物料选择结束回调
const materielSelectDone = (val) => {
  tableData.value = [...val];
  tableData.value.map((i) => {
    i.materialName = i.name;
  });
};

// 选择申请
const handleRequisitionSelectRef = () => {
  requisitionSelectRef.value?.handleDialogOpen();
};

// 申请单选择结束回调
const requisitionSelectDone = (val) => {
  queryRequisitionDetailById(val.id)
    .then((res) => {
      if (res.data.materialList.length > 0) {
        res.data.materialList.forEach((item) => {
          item.changeQuantity = item.applyQuantity;
          item.id = null;
        });
        tableData.value = res.data.materialList;
      }
      for (const key in formData.value) {
        formData.value[key] = res.data[key];
      }
      formData.value.deliverySign = null;
      formData.value.boundSign = null;
      formData.value.boundFileReqs = [];
      if (formData.value.requestDepartmentId) {
        formData.value.requestDepartmentId =
          formData.value.requestDepartmentId.toString();
      }
      if (res.data.type == 2) {
        formData.value.thirdResourceName = res.data.thirdResourceName;
        formData.value.thirdResourceRef = res.data.thirdResourceRef;
      }
      if (res.data.type == 3) {
        formData.value.authOrganizationalDTO = res.data.authOrganizationalDTO;
        formData.value.thirdResourceId = res.data.authOrganizationalDTO.id;
      }
      formData.value.relationNumber = res.data.number;
      formData.value.outType = res.data.type;
    })
    .finally(() => {
      // previewImg(formData.value.annex, fileList);
      loading.value = false;
    });
};

// 新增出库
const addBound = (req) => {
  insertBoundOut(req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// // 获取出库类型列表
// const getTypeList = () => {
//   queryDictList(DICT_KEY["boundTypeOut"]).then((res) => {
//     outStorageTypeList.value = res.data || [];
//   });
// };

// 获取库位列表
const getLocationList = (id) => {
  queryStashById(id).then((res) => {
    locationList.value = res.data.warehousePositionList || [];
  });
};

// 仓库变化
const warehouseChanged = (val) => {
  tableData.value = [];
  locationList.value = [];
  if (val) getLocationList(val);
};

//  文件预览
const previewImg = (fields, target) => {
  let result;
  if (!fields) return (target.value = null);
  axios
    .post(
      "/api/storeroom/file/preview",
      {
        reduceUrl: fields,
      },
      { responseType: "arraybuffer" }
    )
    .then((res) => {
      let url = "";
      const bytes = new Uint8Array(res.data);
      let len = bytes.length;
      for (let i = 0; i < len; i++) {
        url += String.fromCharCode(bytes[i]);
      }
      result = "data:image/jpg;base64," + window.btoa(url);
    })
    .finally(() => {
      target.value = result;
    });
};

const fileSelected = (val) => {
  if (val) {
    uploadSign(val.raw, val.name, "boundFileReqs", true);
  } else {
    formData.value.boundFileReqs = [];
  }
  console.log(formData.value.boundFileReqs);
};

//文件上传
const handleFileUpload = () => {
  uploadRef.value?.handleDialogOpen();
};
// 文件上传ref
const uploadRef = ref(null);

//文件列表
const afterUpload = (result) => {
  console.log("刷新列表", result);
  result.forEach((item) => {
    item.name = item.originalName;
  });
  result.forEach((item) => {
    tableFileData.value.push(item);
  });
};

// 表格列配置
const fileColumns = ref([
  {
    label: "附件名称",
    prop: "name",
  },
  {
    label: "上传人",
    prop: "createByText",
  },
  {
    label: "上传时间",
    prop: "createTime",
  },
]);

//文件列表
const tableFileData = ref([]);

const print = () => {
  // const printContents = document?.getElementById("printBox")?.innerHTML;
  // const originalContents = document.body.innerHTML;
  // hiddenPrintCo;
  // document.body.innerHTML = printContents;
  // window.print();
  // document.body.innerHTML = originalContents;

  // const printContents = document?.getElementById("printBox")?.innerHTML;
  // document.body.innerHTML = printContents;

  // window.print();
  // window.location.reload();
  Print("#printBox", {
    noPrint: ".no-print",
  });

  // const printContents = document?.getElementById("printBox")?.innerHTML;
  // const printContainer = document?.getElementById("hiddenPrintContainer");
  // printContainer.innerHTML = printContents;
  // let printWindow = window.open("", "_blank");
  // printWindow.document.body.innerHTML = printContainer.innerHTML;
  // printWindow.print();
};
// 点击文件下载
const fileDownload = (file) => {
  console.log(file);
  postDownload(
    "/atom/file/download",
    {
      downloadUrl: file.reduceUrl,
    },
    file.name
  );
};
// 暴露函数给父组件
defineExpose({
  handleDialogOpen,
});
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
}

.mt10 {
  margin-top: 5px;
}
.flex-center {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #ccc;
}
.my_class {
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
